import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';

type TrendLinesSectionProps = {
  metricDefinition: MyMetricDefinition;
  calibrationFraming: CalibrationFraming;
};

export const InterpretingTrendLinesSection = ({
  metricDefinition,
  calibrationFraming,
}: TrendLinesSectionProps) => {
  const language = useLanguage();
  return (
    <section
      className="p-6 font-sans col-span-full"
      data-qa="interpretingTrendLinesSection"
    >
      <p className="text-gray-600">
        {language.focusAreaIndicatorsBlurb({
          metricDefinition,
          calibrationFraming,
        })}
      </p>
      <ul className="flex justify-around mt-4 text-sm text-center text-gray-800">
        <li className="flex-shrink w-56">
          <figure data-qa="lowDisparityPresentIllustration">
            <img src={'images/low-disparity-present.svg'} alt="" />
            <figcaption>{language.lowDisparityPresentLabel()}</figcaption>
          </figure>
        </li>
        <li className="flex-shrink w-56">
          <figure data-qa="someDisparityPresentIllustration">
            <img src={'images/some-disparity-present.svg'} alt="" />
            <figcaption>{language.someDisparityPresentLabel()}</figcaption>
          </figure>
        </li>
        <li className="flex-shrink w-56">
          <figure data-qa="disparityPresentIllustration">
            <img src={'images/disparity-present.svg'} alt="" />
            <figcaption>{language.disparityPresentLabel()}</figcaption>
          </figure>
        </li>
      </ul>
    </section>
  );
};
